import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withApollo } from 'react-apollo';
import { loader as Loader } from './Loader'

// let queryResolved = 0
class LoadingWrapper extends Component {

  render() {
    return (
      <div>
        { this.props.settings ? this.props.children : <Loader />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    settings: state.auth.settings
  }
}

export default connect(mapStateToProps, null)(withRouter(withApollo(LoadingWrapper)));



// WEBPACK FOOTER //
// ./src/components/LoadingWrapper.js